import {
    Component,
    OnInit,
    ViewContainerRef,
    ViewChild,
    TemplateRef,
} from '@angular/core';
import { SiteServices } from '../../services/siteservices';

import { Router, Event as NavigationEvent } from '@angular/router';
import { ActivatedRoute } from '@angular/router';

import { BsModalService } from 'ngx-bootstrap/modal';
import { BsModalRef } from 'ngx-bootstrap/modal';

import { Location } from '@angular/common';

import { setTimeout } from 'timers';

import { ModalDialogService } from 'ngx-modal-dialog';
import { ProviderContext } from '../../data/Entities';
import { FileUploader } from 'ng2-file-upload';
import { Helpers } from '../../services/Helpers';

declare var appConfig: any;

@Component({
    selector: 'userfrm2',
    templateUrl: 'templates/get/ProductProvider/productprovider_detail',
})
export class ProviderProductDetailFrm implements OnInit {
    public devicerows: Array<any>;
    public hostrows: Array<any>;

    /**/
    public possibleproducts: Array<any> = [];
    public nameWords: Array<string> = [];
    public filterWords: Array<string> = [];
    public filterWordsJoined: string = '';
    //public newImgURL: string = "";
    public searchC11 = '';
    public searchC22: string;
    public searchC33: string;
    public c1List: any = [];
    public c2List: any = [];
    public c3List: any = [];
    public fList: any = [];
    public rows: any = [];
    public searchC1 = '';
    public searchC2: string;
    public searchC3: string;
    public searchF: string; // functional
    public c11List: any = [];
    public c22List: any = [];
    public c33List: any = [];
    public cantMatch: boolean = false;

    public searchText: string;
    public searchTargetText: string;
    public sourceProd: any;
    public sourceProdArr: any = [];
    public prodprovcategorylist: any;

    public targetList: any = [];
    public promotionUrl: string;
    public promotionPicture: any;

    public errstr: string;
    public entity: any = { Address: {}, PriceHistoryList: [] };
    public entityProductEdit: any = {};
    public modalRef: BsModalRef;
    public submitted = false;
    public isAdmin = true;

    publicnextProdid: number;

    public lineChartData: Array<any> = [{ data: [], label: 'Árak' }];
    public lineChartLabels: Array<any> = [];
    public lineChartOptions: any = {
        responsive: true,
    };

    @ViewChild('mergetemplate')
    private mergeTemplateRef: TemplateRef<any>;

    public lineChartLegend = false;
    public lineChartType = 'line';

    public promoImgWidth;
    public promoImgHeight;

    public MediaServicesUrl: string;
    public uploader: FileUploader;
    isupload: boolean;
    productNameEdit: boolean;
    packageQuantityEdit: boolean;
    WSEdit: boolean;

    constructor(
        public siteServices: SiteServices,
        private route: ActivatedRoute,
        private router: Router,
        private modalService: BsModalService,
        public location: Location,
        public viewRef: ViewContainerRef,
        public modalService2: ModalDialogService
    ) {
        this.MediaServicesUrl = appConfig.MediaServicesUrl;
        console.log(this.MediaServicesUrl);

        this.uploader = new FileUploader({
            url: 'interface/uploadimage/',
        });
    }

    ngOnInit() {
        this.initUpload();

        this.refresh();
    }

    initUpload() {
        this.uploader.onErrorItem = (item, response, status, headers) => {
            this.errstr = 'Hibás feltöltés (' + status + ')';
            this.isupload = false;
        };
        this.uploader.onSuccessItem = (item, response, status, headers) => {
            this.isupload = false;
            let r = JSON.parse(response);
            if (r.ErrStr) {
                this.errstr = r.ErrStr;
                this.siteServices.error(this.errstr);
                return;
            }
            this.entity.ProviderProductImageUrl =
                this.MediaServicesUrl + 'interface/large/' + r.Tag;
            this.saveProductProviderField('ProviderProductImageUrl');
        };
        this.uploader.onBeforeUploadItem = (fileItem) => {
            this.errstr = '';
            this.isupload = true;
        };
        this.uploader.onAfterAddingFile = (fileItem) => {
            this.errstr = '';
            this.isupload = true;
        };
        this.uploader.options['autoUpload'] = true;
    }

    saveProductProviderField(fieldName: string) {
        this.entity.FieldNameToSave = fieldName;
        this.siteServices.provider_Execute(
            'PRODUCTPROVIDER',
            'SAVEFIELD',
            this.entity,
            (data) => {
                this.productNameEdit = false;
                this.packageQuantityEdit = false;
                this.WSEdit = false;

                this.refresh();

                setTimeout((x) => {
                    this.siteServices.success('OK');
                }, 500);
            }
        );
    }

    refresh() {
        this.route.params.subscribe((params) => {
            this.siteServices.provider_GetProvDataByID(
                'productprovider',
                params.id,
                null,
                (data) => {
                    this.entity = data.TagObject;
                    console.log(this.entity);
                    this.initName();

                    //Lekérjük a backendről a SK szülőkategóriáit a prov termék provkategoriájának
                    if (!this.entity.CategoryProvider.CategoryID) {
                        this.siteServices.provider_Execute(
                            'CATEGORY',
                            'GETROOTCATEGORYLIST',
                            {},
                            (data) => {
                                this.c1List = data.TagObject;
                                this.c11List = data.TagObject;
                            }
                        );
                        return;
                    }

                    if (
                        this.entity.ProviderProductImageUrl &&
                        this.entity.ProviderProductImageUrl.length > 0
                    ) {
                    }

                    if (!this.entity.CategoryProvider.CategoryID) {
                        this.siteServices.provider_Execute(
                            'CATEGORY',
                            'GETROOTCATEGORYLIST',
                            {},
                            (data) => {
                                this.c1List = data.TagObject;
                                this.c11List = data.TagObject;
                            }
                        );
                        return;
                    }

                    this.siteServices.provider_Execute(
                        'CATEGORY',
                        'GETPRODATEGORYBYPROVCATEGORY',
                        { CategoryID: this.entity.CategoryProvider.CategoryID },
                        (data) => {
                            this.prodprovcategorylist = data.TagObject;
                            console.log(this.prodprovcategorylist);
                            //Beállítjuk a listában a megfelelő értékeket
                            if (this.prodprovcategorylist[0]) {
                                this.siteServices.provider_Execute(
                                    'CATEGORY',
                                    'GETROOTCATEGORYLIST',
                                    {},
                                    (data) => {
                                        this.c11List = data.TagObject;
                                        this.searchC11 = String(
                                            this.prodprovcategorylist[0]
                                                .CategoryID
                                        );

                                        //Beállítjuk a második szintet
                                        if (this.prodprovcategorylist[1]) {
                                            this.siteServices.provider_Execute(
                                                'CATEGORY',
                                                'GETCATEGORYBYID',
                                                {
                                                    CategoryID:
                                                        this
                                                            .prodprovcategorylist[0]
                                                            .CategoryID,
                                                },
                                                (data) => {
                                                    this.c22List =
                                                        data.TagObject.ChildList;
                                                    this.searchC22 = String(
                                                        this
                                                            .prodprovcategorylist[1]
                                                            .CategoryID
                                                    );

                                                    //Beállítjuk a harmadik kategóriát ha van
                                                    if (
                                                        this
                                                            .prodprovcategorylist[2]
                                                    ) {
                                                        this.siteServices.provider_Execute(
                                                            'CATEGORY',
                                                            'GETCATEGORYBYID',
                                                            {
                                                                CategoryID:
                                                                    this
                                                                        .prodprovcategorylist[1]
                                                                        .CategoryID,
                                                            },
                                                            (data) => {
                                                                this.c33List =
                                                                    data.TagObject.ChildList;
                                                                this.searchC33 =
                                                                    String(
                                                                        this
                                                                            .prodprovcategorylist[2]
                                                                            .CategoryID
                                                                    );
                                                            }
                                                        );
                                                        //Ha nincs harmadik szinthez rendelve, akkor leszedjük a harmadik szint listáját
                                                    } else {
                                                        const cid =
                                                            this
                                                                .prodprovcategorylist[1]
                                                                .CategoryID;
                                                        if (!cid) {
                                                            this.c33List = [];
                                                            this.searchC33 = '';
                                                            return;
                                                        }
                                                        this.siteServices.provider_Execute(
                                                            'CATEGORY',
                                                            'GETCATEGORYBYID',
                                                            { CategoryID: cid },
                                                            (data) => {
                                                                this.c33List =
                                                                    data.TagObject.ChildList;
                                                                this.searchC33 =
                                                                    '';
                                                            }
                                                        );
                                                    }
                                                }
                                            );
                                        }
                                    }
                                );
                            }
                        }
                    );
                }
            );
        });
    }

    imageExists(image_url) {
        var image = new Image();
        image.src = image_url;
        if (image.width == 0) {
            return false;
        } else {
            return true;
        }
    }

    initName() {
        this.nameWords = this.entity.ProviderProductName.split(' ');
    }

    saverange(newValue) {
        this.filterWords = newValue.split(' ');
        this.filterWordsJoined = this.filterWords.join(' ');
        console.log(this.filterWords);
    }

    changeImg(newImgURL) {
        this.entity.ProviderProductImageUrl = newImgURL;
    }

    addToFilterName(row: any) {
        if (this.filterWords.indexOf(row) == -1) {
            this.filterWords.push(row);
        }

        console.log(this.filterWords);
        this.filterWordsJoined = this.filterWords.join(' ');
        console.log(this.filterWordsJoined);
    }

    //Lekérdezi a megfelelő termékeket
    startChallenge() {
        window.location.href = window.location.href + '#cselendzs';
        /**Betölti a többi kis providert*/
        console.log('Hello');

        console.log(this.entity.ProductProviderID);
        this.possibleproducts = [];

        this.siteServices.provider_GetMissingSimilarProducts(
            'getMissingSimilarProviderProducts',
            this.entity.ProductProviderID,
            Helpers.ConvertToBase64(this.filterWords.join('_')),
            '',
            (data) => {
                var tmpShit = data.TagObject;
                if (tmpShit.length > 0) {
                    this.possibleproducts.push(tmpShit);
                    console.log(tmpShit);
                }
            }
        );
        console.log(this.possibleproducts);
    }

    //Ha már ott van egy termék csak rosszul, akkor az nem kell
    detachProductProvider(row: any) {
        this.siteServices.provider_Execute(
            'PRODUCT',
            'DETACH',
            row.ProductProviderID,
            (data) => {
                alert('ok, leválasztva');

                this.refresh();
                setTimeout((x) => {
                    this.siteServices.success('Leválasztás OK');
                }, 500);
            }
        );
    }

    //Elkészíti a
    detachProduct() {
        let key = null;

        if (this.searchC33) {
            key = this.searchC33;
        } else if (this.searchC22) {
            key = this.searchC22;
        } else if (this.searchC11) {
            key = this.searchC11;
        }

        if (!key) {
            this.siteServices.error('Nincs célkategória kiválasztva');
            return;
        }

        this.siteServices.provider_Execute(
            'PRODUCT',
            'MAKEPRODUCTFROMPROVPROD',
            this.entity.ProductProviderID +
                '_' +
                key +
                '#' +
                this.entity.ProviderProductImageUrl,
            (data) => {
                alert(data.TagObject);
                if (data.TagObject == 'ok') {
                    this.cantMatch = false;
                }
                setTimeout((x) => {
                    this.refresh();

                    this.siteServices.success('Leválasztás OK');
                }, 500);
            }
        );
    }

    public setGroupCategory() {
        var arr = [this.entity.ProductID];

        let key = null;

        if (this.searchC33) {
            key = this.searchC33;
        } else if (this.searchC22) {
            key = this.searchC22;
        } else if (this.searchC11) {
            key = this.searchC11;
        }

        if (!key) {
            this.siteServices.error('Nincs célkategória kiválasztva');
            return;
        }

        console.log(arr);
        console.log(key);
        this.siteServices.provider_Execute(
            'PRODUCT',
            'SETCATEGORY',
            { productArr: arr, targetCategory: key },
            (data) => {
                this.refresh();
                setTimeout((x) => {
                    this.siteServices.success(
                        'Átmozgatás OK -' + arr.length + ' db.'
                    );
                }, 500);
            }
        );
    }

    matchProduct(item: any) {
        //console.log(item);
        this.siteServices.provider_Execute(
            'PRODUCT',
            'MERGEPRODPROV',
            this.entity.ProductProviderID + '_' + item.ProductID,
            (data) => {}
        );
        setTimeout((x) => {
            this.siteServices.success('Összerendelés OK');
            var i = 0;
            this.possibleproducts.forEach((p) => {
                console.log(p[0].ProviderID + '___' + item.ProviderID);
                if (p[0].ProviderID == item.ProviderID) {
                    p = [];
                    console.log(i);
                    this.possibleproducts.splice(i, 1);
                }
                i++;
            });

            // console.log(this.possibleproducts);
            this.refresh();
        }, 2000);
    }

    notMatchedRow(prid) {
        var i = 0;
        this.possibleproducts.splice(i, 1);
        this.cantMatch = true;
        this.refresh();
    }

    save(frm) {
        /*  this.submitted = true;
        if (!frm.valid) {
            this.siteServices.error("Hibás kitöltés!");
            return;
        }
        */

        this.siteServices.provider_Execute(
            'PRODUCT',
            'SAVEPRODUCTEDIT',
            this.entityProductEdit,
            (data) => {
                window.scrollTo(0, 0);
                setTimeout((x) => {
                    this.siteServices.success('OK');
                    this.entity = data.TagObject;
                }, 50);
            }
        );
    }

    makeMainPhoto(productProviderID) {
        this.siteServices.provider_Execute(
            'PRODUCT',
            'SETMAINIMAGE',
            productProviderID,
            (data) => {
                this.refresh();
                setTimeout((x) => {
                    this.siteServices.success('Beállítás OK');
                }, 500);
            }
        );
    }

    onFileSelected(event) {
        const reader = new FileReader();
        const file = event.target.files[0];
        reader.readAsDataURL(file);
        reader.onload = () => {
            const img = new Image();
            img.onload = () => {
                this.promoImgWidth = img.width;
                this.promoImgHeight = img.height;
            };
            img.src = <string>reader.result;
            console.log(reader.result);
            this.entityProductEdit.PromotionPicture = reader.result;
        };
    }

    setPromotion() {
        if (
            !this.promoImgWidth ||
            (this.promoImgHeight && this.promoImgWidth <= 0) ||
            this.promoImgHeight <= 0
        ) {
            this.siteServices.error(
                'Tölts fel egy promóciós képet a mentéshez!'
            );
            return;
        }

        const imageRatio =
            Math.round((this.promoImgWidth / this.promoImgHeight) * 100) / 100;

        if (imageRatio < 5.5 || imageRatio > 6.5) {
            this.siteServices.error(
                `A Promóciós képnek az aránya (5,5 x 1) és (6,5 x 1) között kell lennie 'Szélesség x Magasság'! Aktuális kép méret: ${this.promoImgWidth} x ${this.promoImgHeight}, és az arány: ${imageRatio}!`
            );
            return;
        }

        this.siteServices.provider_Execute(
            'PRODUCT',
            'SETPROMOTION',
            this.entityProductEdit,
            (data) => {
                setTimeout((x) => {
                    this.siteServices.success('Promóció mentve');
                }, 50);
            }
        );
    }

    delPromotion() {
        this.siteServices.provider_Execute(
            'PRODUCT',
            'DELPROMOTION',
            this.entityProductEdit,
            (data) => {
                setTimeout((x) => {
                    this.siteServices.success('Promóció törölve');
                    this.entityProductEdit = data.TagObject;
                }, 50);
            }
        );
    }

    public chgcat1(ev) {
        const cid = ev.target.value;

        this.c2List = [];
        this.searchC2 = '';
        this.c3List = [];
        this.searchC3 = '';
        this.fList = [];
        this.searchF = '';

        if (!cid) {
            return;
        }

        this.siteServices.provider_Execute(
            'CATEGORY',
            'GETCATEGORYBYID',
            { CategoryID: cid },
            (data) => {
                this.c2List = data.TagObject.ChildList;
            }
        );
    }

    public chgcat2(ev) {
        const cid = ev.target.value;

        this.c3List = [];
        this.searchC3 = '';
        this.fList = [];
        this.searchF = '';

        if (!cid) {
            return;
        }
        this.siteServices.provider_Execute(
            'CATEGORY',
            'GETCATEGORYBYID',
            { CategoryID: cid },
            (data) => {
                this.c3List = data.TagObject.ChildList;
                if (this.c3List.length === 0) {
                    // LEVÉL - lehet gyneve
                    this.siteServices.provider_Execute(
                        'PRODUCT',
                        'GETFUNCTIONALNAMES',
                        { targetCategory: cid },
                        (data2) => {
                            this.fList = data2.TagObject;
                        }
                    );
                }
            }
        );
    }

    public chgcat3(ev) {
        const cid = ev.target.value;

        this.fList = [];
        this.searchF = '';

        if (!cid) {
            return;
        }
        this.siteServices.provider_Execute(
            'PRODUCT',
            'GETFUNCTIONALNAMES',
            { targetCategory: cid },
            (data) => {
                this.fList = data.TagObject;
            }
        );
    }

    public chgcat11(ev) {
        const cid = ev.target.value;
        this.c33List = [];
        this.searchC33 = '';
        if (!cid) {
            this.c22List = [];
            this.searchC22 = '';
            return;
        }
        this.siteServices.provider_Execute(
            'CATEGORY',
            'GETCATEGORYBYID',
            { CategoryID: cid },
            (data) => {
                this.c22List = data.TagObject.ChildList;
                this.searchC22 = '';
            }
        );
    }

    public chgcat22(ev) {
        const cid = ev.target.value;
        if (!cid) {
            this.c33List = [];
            this.searchC33 = '';
            return;
        }
        this.siteServices.provider_Execute(
            'CATEGORY',
            'GETCATEGORYBYID',
            { CategoryID: cid },
            (data) => {
                this.c33List = data.TagObject.ChildList;
                this.searchC33 = '';
            }
        );
    }

    public mergeProduct() {
        this.sourceProd = this.entity;
        this.sourceProdArr = this.entity.ProductName.split(' ');

        this.targetList = [];
        const a = this.entity.ProductName.split(' ');
        this.searchTargetText = this.filterWords.join(' ');

        if (
            this.searchText &&
            this.searchText
                .toLowerCase()
                .startsWith(this.searchTargetText.toLowerCase())
        ) {
            this.searchTargetText = this.searchText;
        }

        // + (a.length > 1 ? " " + a[1] : "");
        this.modalRef = this.modalService.show(this.mergeTemplateRef, {
            class: 'modal-lg',
        });
        this.searchTargetList();
    }

    public searchTargetList() {
        const dtx2: ProviderContext = new ProviderContext({
            ProviderCode: 'PRODUCT',
            SortField: 'ProductName',
            IsAsc: true,
            ItemsPerPage: 100000,
        });

        dtx2.addFilter('ProductName', this.searchTargetText);
        // dtx2.addFilter("CategoryID", this.sourceProd.CategoryID);
        dtx2.addFilter('MatchSourceProductID', this.sourceProd.ProductID);
        this.siteServices.inProgress = true;
        this.siteServices.provider_Execute(
            'PRODUCT',
            'FINDMATCHING',
            dtx2,
            (data) => {
                // szürés hasonló bolt
                this.targetList = data.TagObject;
                this.siteServices.inProgress = false;
            }
        );
    }

    public addSearch(token: string) {
        this.searchTargetText += ' ' + token;
    }

    public doMerge(targetProd: any) {
        this.siteServices.provider_Execute(
            'PRODUCT',
            'MERGE',
            {
                sourceID: this.sourceProd.ProductID,
                targetID: targetProd.ProductID,
            },
            (data) => {
                console.log(data);
                this.refresh();
            }
        );
    }

    public setStatus() {
        console.log(this.entity);

        let shopsSelected = this.getCookie('shopsSelected');
        let categoriesSelected = this.getCookie('categoriesSelected');
        let onlyAvailable = this.getCookie('onlyAvailable');

        setTimeout((x) => {
            this.siteServices.provider_Execute(
                'PRODUCT',
                'GETNEXTPROVPRODID',
                {
                    shopsSelected: shopsSelected,
                    categoriesSelected: categoriesSelected,
                    onlyAvailable: onlyAvailable,
                },
                (data) => {
                    this.publicnextProdid = data.TagObject;

                    this.router
                        .navigate([
                            'productprovideredit',
                            this.publicnextProdid,
                        ])
                        .then((_ev) => {});
                    // this.refresh();

                    // setTimeout(x => { this.siteServices.success("Beállítás OK"); }, 500);
                }
            );
            scroll(0, 0);
        }, 500);
    }

    private getCookie(name) {
        const value = `; ${document.cookie}`;
        const parts = value.split(`; ${name}=`);
        if (parts.length === 2) return parts.pop().split(';').shift();
    }

    public deleteProdProv() {
        this.siteServices.provider_Execute(
            'PRODUCT',
            'DELPROVPROD',
            this.entity.ProductProviderID,
            (data) => {
                console.log(data.TagObject);
                setTimeout((x) => {
                    this.siteServices.provider_Execute(
                        'PRODUCT',
                        'GETNEXTPROVPRODID',
                        0, //erre nincs is szükség igazán
                        (data) => {
                            console.log(data);
                            this.publicnextProdid = data.TagObject;
                            console.log(this.publicnextProdid);
                            this.router
                                .navigate([
                                    'productprovideredit',
                                    this.publicnextProdid,
                                ])
                                .then((_ev) => {});
                        }
                    );
                    scroll(0, 0);
                }, 500);
                this.refresh();
            }
        );

        this.siteServices.provider_Execute(
            'PRODUCT',
            'GETNEXTPROVPRODID',
            this.entity.ProductID,
            (data) => {
                console.log(data);
                this.publicnextProdid = data.TagObject;
                console.log(this.publicnextProdid);
                this.router
                    .navigate(['productprovideredit', this.publicnextProdid])
                    .then((_ev) => {});
                // this.refresh();

                // setTimeout(x => { this.siteServices.success("Beállítás OK"); }, 500);
            }
        );
        scroll(0, 0);
    }
}
